/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    UpcomingShowCreateGiveawayItemRequest,
    UpcomingShowCreateGiveawayItemResponse,
    UpcomingShowCreateGiveawayWinnerRequest,
} from '../models';

export interface UpcomingShowGiveawayItemApiControllerCancelGiveawayItemRequest {
    upcomingShowId: string;
    giveawayItemId: string;
}

export interface UpcomingShowGiveawayItemApiControllerCheckEntrantEligibilityRequest {
    upcomingShowId: string;
    giveawayItemId: string;
    entrantId: string;
}

export interface UpcomingShowGiveawayItemApiControllerCreateGiveawayEntrantRequest {
    upcomingShowId: string;
    giveawayItemId: string;
}

export interface UpcomingShowGiveawayItemApiControllerCreateGiveawayItemRequest {
    upcomingShowId: string;
    upcomingShowCreateGiveawayItemRequest: UpcomingShowCreateGiveawayItemRequest;
}

export interface UpcomingShowGiveawayItemApiControllerCreateGiveawayWinnerRequest {
    upcomingShowId: string;
    giveawayItemId: string;
    upcomingShowCreateGiveawayWinnerRequest: UpcomingShowCreateGiveawayWinnerRequest;
}

export interface UpcomingShowGiveawayItemApiControllerRemoveGiveawayItemRequest {
    upcomingShowId: string;
    giveawayItemId: string;
}

/**
 * 
 */
export class UpcomingShowGiveawayItemApi extends runtime.BaseAPI {

    /**
     */
    async upcomingShowGiveawayItemApiControllerCancelGiveawayItemRaw(requestParameters: UpcomingShowGiveawayItemApiControllerCancelGiveawayItemRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowGiveawayItemApiControllerCancelGiveawayItem.');
        }

        if (requestParameters.giveawayItemId === null || requestParameters.giveawayItemId === undefined) {
            throw new runtime.RequiredError('giveawayItemId','Required parameter requestParameters.giveawayItemId was null or undefined when calling upcomingShowGiveawayItemApiControllerCancelGiveawayItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/giveaway-items/{giveawayItemId}:cancel`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))).replace(`{${"giveawayItemId"}}`, encodeURIComponent(String(requestParameters.giveawayItemId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upcomingShowGiveawayItemApiControllerCancelGiveawayItem(requestParameters: UpcomingShowGiveawayItemApiControllerCancelGiveawayItemRequest): Promise<void> {
        await this.upcomingShowGiveawayItemApiControllerCancelGiveawayItemRaw(requestParameters);
    }

    /**
     */
    async upcomingShowGiveawayItemApiControllerCheckEntrantEligibilityRaw(requestParameters: UpcomingShowGiveawayItemApiControllerCheckEntrantEligibilityRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowGiveawayItemApiControllerCheckEntrantEligibility.');
        }

        if (requestParameters.giveawayItemId === null || requestParameters.giveawayItemId === undefined) {
            throw new runtime.RequiredError('giveawayItemId','Required parameter requestParameters.giveawayItemId was null or undefined when calling upcomingShowGiveawayItemApiControllerCheckEntrantEligibility.');
        }

        if (requestParameters.entrantId === null || requestParameters.entrantId === undefined) {
            throw new runtime.RequiredError('entrantId','Required parameter requestParameters.entrantId was null or undefined when calling upcomingShowGiveawayItemApiControllerCheckEntrantEligibility.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/giveaway-items/{giveawayItemId}/entrants/{entrantId}:checkEligibility`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))).replace(`{${"giveawayItemId"}}`, encodeURIComponent(String(requestParameters.giveawayItemId))).replace(`{${"entrantId"}}`, encodeURIComponent(String(requestParameters.entrantId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upcomingShowGiveawayItemApiControllerCheckEntrantEligibility(requestParameters: UpcomingShowGiveawayItemApiControllerCheckEntrantEligibilityRequest): Promise<void> {
        await this.upcomingShowGiveawayItemApiControllerCheckEntrantEligibilityRaw(requestParameters);
    }

    /**
     */
    async upcomingShowGiveawayItemApiControllerCreateGiveawayEntrantRaw(requestParameters: UpcomingShowGiveawayItemApiControllerCreateGiveawayEntrantRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowGiveawayItemApiControllerCreateGiveawayEntrant.');
        }

        if (requestParameters.giveawayItemId === null || requestParameters.giveawayItemId === undefined) {
            throw new runtime.RequiredError('giveawayItemId','Required parameter requestParameters.giveawayItemId was null or undefined when calling upcomingShowGiveawayItemApiControllerCreateGiveawayEntrant.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/giveaway-items/{giveawayItemId}/entrants`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))).replace(`{${"giveawayItemId"}}`, encodeURIComponent(String(requestParameters.giveawayItemId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upcomingShowGiveawayItemApiControllerCreateGiveawayEntrant(requestParameters: UpcomingShowGiveawayItemApiControllerCreateGiveawayEntrantRequest): Promise<void> {
        await this.upcomingShowGiveawayItemApiControllerCreateGiveawayEntrantRaw(requestParameters);
    }

    /**
     */
    async upcomingShowGiveawayItemApiControllerCreateGiveawayItemRaw(requestParameters: UpcomingShowGiveawayItemApiControllerCreateGiveawayItemRequest): Promise<runtime.ApiResponse<UpcomingShowCreateGiveawayItemResponse>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowGiveawayItemApiControllerCreateGiveawayItem.');
        }

        if (requestParameters.upcomingShowCreateGiveawayItemRequest === null || requestParameters.upcomingShowCreateGiveawayItemRequest === undefined) {
            throw new runtime.RequiredError('upcomingShowCreateGiveawayItemRequest','Required parameter requestParameters.upcomingShowCreateGiveawayItemRequest was null or undefined when calling upcomingShowGiveawayItemApiControllerCreateGiveawayItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/giveaway-items`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.upcomingShowCreateGiveawayItemRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async upcomingShowGiveawayItemApiControllerCreateGiveawayItem(requestParameters: UpcomingShowGiveawayItemApiControllerCreateGiveawayItemRequest): Promise<UpcomingShowCreateGiveawayItemResponse> {
        const response = await this.upcomingShowGiveawayItemApiControllerCreateGiveawayItemRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async upcomingShowGiveawayItemApiControllerCreateGiveawayWinnerRaw(requestParameters: UpcomingShowGiveawayItemApiControllerCreateGiveawayWinnerRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowGiveawayItemApiControllerCreateGiveawayWinner.');
        }

        if (requestParameters.giveawayItemId === null || requestParameters.giveawayItemId === undefined) {
            throw new runtime.RequiredError('giveawayItemId','Required parameter requestParameters.giveawayItemId was null or undefined when calling upcomingShowGiveawayItemApiControllerCreateGiveawayWinner.');
        }

        if (requestParameters.upcomingShowCreateGiveawayWinnerRequest === null || requestParameters.upcomingShowCreateGiveawayWinnerRequest === undefined) {
            throw new runtime.RequiredError('upcomingShowCreateGiveawayWinnerRequest','Required parameter requestParameters.upcomingShowCreateGiveawayWinnerRequest was null or undefined when calling upcomingShowGiveawayItemApiControllerCreateGiveawayWinner.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/giveaway-items/{giveawayItemId}:createWinner`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))).replace(`{${"giveawayItemId"}}`, encodeURIComponent(String(requestParameters.giveawayItemId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.upcomingShowCreateGiveawayWinnerRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upcomingShowGiveawayItemApiControllerCreateGiveawayWinner(requestParameters: UpcomingShowGiveawayItemApiControllerCreateGiveawayWinnerRequest): Promise<void> {
        await this.upcomingShowGiveawayItemApiControllerCreateGiveawayWinnerRaw(requestParameters);
    }

    /**
     */
    async upcomingShowGiveawayItemApiControllerRemoveGiveawayItemRaw(requestParameters: UpcomingShowGiveawayItemApiControllerRemoveGiveawayItemRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowGiveawayItemApiControllerRemoveGiveawayItem.');
        }

        if (requestParameters.giveawayItemId === null || requestParameters.giveawayItemId === undefined) {
            throw new runtime.RequiredError('giveawayItemId','Required parameter requestParameters.giveawayItemId was null or undefined when calling upcomingShowGiveawayItemApiControllerRemoveGiveawayItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/giveaway-items/{giveawayItemId}`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))).replace(`{${"giveawayItemId"}}`, encodeURIComponent(String(requestParameters.giveawayItemId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upcomingShowGiveawayItemApiControllerRemoveGiveawayItem(requestParameters: UpcomingShowGiveawayItemApiControllerRemoveGiveawayItemRequest): Promise<void> {
        await this.upcomingShowGiveawayItemApiControllerRemoveGiveawayItemRaw(requestParameters);
    }

}
